import { io, Socket } from 'socket.io-client';
import { baseURL } from './constants/env';

let sharedSocket: Socket | null = null;

export const getSocketBaseUrl = (): string => {
    return baseURL.replace('/api/v1', '');
};

export const getSocket = (): Socket | null => {
    const token = localStorage.getItem('access_token');
    if (!token) {
        if (sharedSocket) {
            sharedSocket.disconnect();
            sharedSocket = null;
        }
        return null;
    }

    if (!sharedSocket || !sharedSocket.connected) {
        const socketBaseUrl = getSocketBaseUrl();
        sharedSocket = io(socketBaseUrl, {
            auth: { token },
            query: { token },
            transports: ['websocket'],
            timeout: 10000,
            reconnectionAttempts: 5
        });
    }

    return sharedSocket;
};

export const setSharedSocket = (socket: Socket | null) => {
    sharedSocket = socket;
};

export const createDedicatedSocket = (): Socket | null => {
    const token = localStorage.getItem('access_token');
    if (!token) return null;
    const socketBaseUrl = getSocketBaseUrl();
    return io(socketBaseUrl, {
        auth: { token },
        query: { token },
        transports: ['websocket'],
        timeout: 10000,
        reconnectionAttempts: 5
    });
};

export const disconnectSharedSocket = () => {
    if (sharedSocket) {
        sharedSocket.disconnect();
        sharedSocket = null;
    }
};
